<template>
  <el-dialog
        :title="$t('settlement.TransactionSettlement')"
        :visible="visible"
        width="70%"
        top="5vh"
        append-to-body
        @close="handleClose"
    >
    <!-- 明细表格 -->
    <el-table :data="tableData" style="width: 100%" v-loading="loading" border height="50vh">
      <el-table-column prop="trTsId" :label="$t('settlement.tsId')" width="120" />
      <el-table-column prop="trType" :label="$t('settlement.tsdSettType')" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.trType === 1">{{$t('settlement.tsdSettType1')}}</span>
          <span v-else-if="scope.row.trType === 2">{{$t('settlement.tsdSettType2')}}</span>
          <span v-else>{{$t('unknownStatus')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="trGwNo" :label="$t('settlement.tsdGwNo')" width="160" />
      <el-table-column prop="trNo" :label="$t('settlement.trNo')" width="240" />
      <el-table-column prop="trCurrency" :label="$t('settlement.tsdCurrency')" width="120" />
      <el-table-column prop="trSettCurrency" :label="$t('settlement.tsdSettCurrency')" width="120" />
      <el-table-column prop="trSettRate" :label="$t('settlement.trSettRate')" width="120" />
      <el-table-column prop="trAmount" :label="$t('settlement.trAmount')" width="180" />
      <el-table-column prop="trStatus" :label="$t('settlement.tsdSettType')" width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.trStatus === -2">{{$t('settlement.trStatus_2')}}</span>
          <span v-else-if="scope.row.trStatus === -1">{{$t('settlement.trStatus_1')}}</span>
          <span v-else-if="scope.row.trStatus === 0">{{$t('settlement.trStatus0')}}</span>
          <span v-else-if="scope.row.trStatus === 1">{{$t('settlement.trStatus1')}}</span>
          <span v-else>{{$t('unknownStatus')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="trTradeRate" :label="$t('settlement.trTradeRate')" width="180" />
      <el-table-column prop="trSppCurrency" :label="$t('settlement.trSppCurrency')" width="180" />
      <el-table-column prop="trSpp" :label="$t('settlement.trSpp')" width="180" />
      <el-table-column prop="trReseverRate" :label="$t('settlement.trReseverRate')" width="180" />
      <el-table-column prop="trDatetime" :label="$t('settlement.trDatetime')" width="180" />

      <el-table-column prop="trRefundment" :label="$t('settlement.trRefundment')" width="180" >
        <template slot-scope="scope">
          <span v-if="scope.row.trRefundment === 0">{{$t('settlement.trRefundment0')}}</span>
          <span v-else-if="scope.row.trRefundment === 1">{{$t('settlement.trRefundment1')}}</span>
          <span v-else>{{$t('unknownStatus')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="trProtest" :label="$t('settlement.trProtest')" width="180" >
        <template slot-scope="scope">
          <span v-if="scope.row.trProtest === 0">{{$t('settlement.trProtest0')}}</span>
          <span v-else-if="scope.row.trProtest === 1">{{$t('settlement.trProtest1')}}</span>
          <span v-else>{{$t('unknownStatus')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="trCongeal" :label="$t('settlement.trCongeal')" width="180" >
        <template slot-scope="scope">
          <span v-if="scope.row.trCongeal === 0">{{$t('settlement.trCongeal0')}}</span>
          <span v-else-if="scope.row.trCongeal === 1">{{$t('settlement.trCongeal1')}}</span>
          <span v-else>{{$t('unknownStatus')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="trIsexplain" :label="$t('settlement.trIsexplain')" width="180" >
        <template slot-scope="scope">
          <span v-if="scope.row.trIsexplain === -2">{{$t('settlement.trIsexplain_2')}}</span>
          <span v-else-if="scope.row.trIsexplain === -1">{{$t('settlement.trIsexplain_1')}}</span>
          <span v-else-if="scope.row.trIsexplain === 0">{{$t('settlement.trIsexplain0')}}</span>
          <span v-else-if="scope.row.trIsexplain === 1">{{$t('settlement.trIsexplain1')}}</span>
          <span v-else>{{$t('unknownStatus')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="trRefundmentAmount" :label="$t('settlement.trRefundmentAmount')" width="180" />
      <el-table-column prop="trProtestAmount" :label="$t('settlement.trProtestAmount')" width="180" />
      <el-table-column prop="trCongealAmount" :label="$t('settlement.trCongealAmount')" width="180" />
      <el-table-column prop="trFEEFailMER" :label="$t('settlement.trFEEFailMER')" width="180" >
        <template slot-scope="scope">
          <span v-if="scope.row.trFEEFailMER === 0">{{$t('settlement.uncollect')}}</span>
          <span v-else-if="scope.row.trFEEFailMER === 1">{{$t('settlement.collect')}}</span>
          <span v-else>{{$t('unknownStatus')}}</span>
        </template>
      </el-table-column>

      <el-table-column prop="trFEESuccessMER" :label="$t('settlement.trFEESuccessMER')" width="180" >
        <template slot-scope="scope">
          <span v-if="scope.row.trFEESuccessMER === 0">{{$t('settlement.uncollect')}}</span>
          <span v-else-if="scope.row.trFEESuccessMER === 1">{{$t('settlement.collect')}}</span>
          <span v-else>{{$t('unknownStatus')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="trFEESuccessAfterMER" :label="$t('settlement.trFEESuccessAfterMER')" width="180" >
        <template slot-scope="scope">
          <span v-if="scope.row.trFEESuccessAfterMER === 0">{{$t('settlement.uncollect')}}</span>
          <span v-else-if="scope.row.trFEESuccessAfterMER === 1">{{$t('settlement.collect')}}</span>
          <span v-else>{{$t('unknownStatus')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="trIsBackMER" :label="$t('settlement.trIsBackMER')" width="180" >
        <template slot-scope="scope">
          <span v-if="scope.row.trIsBackMER === 0">{{$t('settlement.uncollect')}}</span>
          <span v-else-if="scope.row.trIsBackMER === 1">{{$t('settlement.collect')}}</span>
          <span v-else>{{$t('unknownStatus')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="trIsBackAfterMER" :label="$t('settlement.trIsBackAfterMER')" width="180" >
        <template slot-scope="scope">
          <span v-if="scope.row.trIsBackAfterMER === 0">{{$t('settlement.uncollect')}}</span>
          <span v-else-if="scope.row.trIsBackAfterMER === 1">{{$t('settlement.collect')}}</span>
          <span v-else>{{$t('unknownStatus')}}</span>
        </template>
      </el-table-column>
    </el-table>

    <!-- 独立的分页器 -->
    <div style="margin-top: 15px; display: flex; justify-content: flex-end;">
      <el-pagination
          :current-page="pagination.page"
          :page-size="pagination.limit"
          :total="pagination.total"
          :page-sizes="[10, 20, 50]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      />
    </div>
  </el-dialog>
</template>

<script>

export default {
  name: 'TransferFundsDetail',
  // 2. 定义 Props
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rowId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      // 3. 定义组件内部状态
      loading: false,
      tableData: [],
      pagination: {
        page: 1,
        limit: 10,
        total: 0
      }
    };
  },
  methods: {
    // 4. 定义方法
    async fetchData() {
      if (!this.rowId) return;
      this.loading = true;
      try {
        const res = await this.$axios.post('/api/settlement/transaction', {
          id: this.rowId,
          page: this.pagination.page,
          limit: this.pagination.limit
        });

        if (res.data.code === 0) {
          const responseData = res.data.data;
          this.tableData = res.data.data.records || [];
          this.pagination.total = Number(res.data.data.total) || 0;
          this.pagination.page = Number(responseData.current) || this.pagination.page;
          this.pagination.limit = Number(responseData.size) || this.pagination.limit;
        } else {
          this.$message.error(res.data.msg);
          this.tableData = [];
          this.pagination.total = 0;
        }
      } catch (err) {
        console.error('查询明细失败:', err);
      } finally {
        this.loading = false;
      }
    },
    handleClose() {
      // 关闭时，通过 update:visible 事件通知父组件
      this.$emit('close');
      this.tableData = [];
      this.pagination.total = 0;
    },
    handleSizeChange(newLimit) {
      this.pagination.limit = newLimit;
      this.fetchData();
    },
    handleCurrentChange(newPage) {
      this.pagination.page = newPage;
      this.fetchData();
    }
  },
  watch: {
    // 5. 监听 props 变化
    visible(newVal) {
      if (newVal) {
        this.pagination.page = 1; // 每次打开强制回到第一页
        this.fetchData();
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/view/transactionSettlement/TransactionSettlement.vue